module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/349.1b9aaf56.png";